import styled from 'styled-components'
import WizrFlexLayout from './WizrFlexLayout'

// const TicketNumber = styled.span<{ color: string }>`
//   color: ${(props) => props.color};
const TicketNumber = styled.span`
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  min-width: 30px;
  display: inline-block;
`

interface TicketCountDisplayProps {
  text: any;
  type: 'total_tickets' | 'open_tickets';
}

const TicketCountDisplay = ({ text, type }: TicketCountDisplayProps): JSX.Element => {

  return (
    <WizrFlexLayout background='white' flexDirection='row' justifyContent='center' alignItems='center' style={{ gap: "4px" }}>
      {/* <TicketNumber color={tagColor}> */}
      <TicketNumber>
        {text}
      </TicketNumber>
    </WizrFlexLayout>
  )
}

export default TicketCountDisplay 